import API from "../api/axios";

export const getCallAnalytics = () => {
   return API.get("/telecmi/analytics");
};